import React, { useEffect, useMemo, useState } from "react";
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";

import { format } from "date-fns";
import { fr } from "date-fns/locale";

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import DeleteModal from '../../components/Common/DeleteModal';


import AcademicCycleConfigModal from "./partials/AcademicCycleConfigModal";

import {
    getAcademicCycleConfigs as onGetAcademicCycleConfigs,
    addNewAcademicCycleConfig as onAddNewAcademicCycleConfig,
    updateAcademicCycleConfig as onUpdateAcademicCycleConfig,
    deleteAcademicCycleConfig as onDeleteAcademicCycleConfig,
} from "store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

import {
    Col,
    Row,
    UncontrolledTooltip,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    Input,
    FormFeedback,
    Label,
    Card,
    CardBody,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Badge,
    Button,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";

const AcademicCycleConfigList = () => {

    //meta title
    document.title = "Cycles | CinzanEdu";

    const [modal, setModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [academicCycleConfig, setAcademicCycleConfig] = useState(null);
    


 
    const dispatch = useDispatch();

    const AcademicCycleConfigProperties = createSelector(
        (state) => state.academicCycleConfigReducer,
        (academicCycleConfigReducer) => ({
            academicCycleConfigs: academicCycleConfigReducer.academicCycleConfigs,
            loading: academicCycleConfigReducer.loading
        })
    );

    const {academicCycleConfigs, loading} = useSelector(AcademicCycleConfigProperties);

    const [isLoading, setLoading] = useState(loading)

    useEffect(() => {


        if (academicCycleConfigs && !academicCycleConfigs.length) {
            
            dispatch(onGetAcademicCycleConfigs());
        }
    }, [dispatch, academicCycleConfigs]);

    const toggle = () => {
        if (modal) {
            setModal(false);
            setAcademicCycleConfig(null);
        } else {
            setModal(true);
        }
    };

    const handleAcademicCycleConfigClick = arg => {
        const academicCycleConfig = arg;
        setAcademicCycleConfig({
            id: academicCycleConfig.id,
            uuid: academicCycleConfig.uuid,
            name: academicCycleConfig.name,
            level: academicCycleConfig.level,
            max_retakes_allowed: academicCycleConfig.max_retakes_allowed,
            

        });


        // Set for update url
        setIsEdit(true);

        toggle();
    };

    //delete Serial movie
    const [deleteModal, setDeleteModal] = useState(false);

    const onClickDelete = (academicCycleConfig) => {
        setAcademicCycleConfig(academicCycleConfig);
        setDeleteModal(true);
    };

    const handleDeleteAcademicCycleConfig = () => {
        if (academicCycleConfig && academicCycleConfig.id) {
            //dispatch(onDeleteSerialeventCategory(serialeventCategory.id));
            dispatch(onDeleteAcademicCycleConfig(academicCycleConfig));
            setDeleteModal(false);
        }
    };

    const onClickNewAcademicCycleConfig = () => {
        setIsEdit(false);
        setAcademicCycleConfig(null);
        toggle();
        //setModal(true)
    };

    const columns = useMemo(
        () => [
            {
                header: 'ID',
                accessorKey: "id",
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return <Link to="#" className="text-body fw-bold">{cellProps.row.original.id}</Link>
                }
            },
            {
                header: "Nom",
                accessorKey: "name",
                enableColumnFilter: false,
                enableSorting: true,
            },
                {
                header: "Niveau",
                accessorKey: "level",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Nbre de redoublements autorisés",
                accessorKey: "max_retakes_allowed",
                enableColumnFilter: false,
                enableSorting: true,
            },
           
    
            
            
            
            {
                header: 'Action',
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0">
                            
                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-info"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        handleAcademicCycleConfigClick(jobData);
                                    }}
                                    id={`edittooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-pencil-outline" />
                                    <UncontrolledTooltip placement="top" target={`edittooltip-${cellProps.row.original.id}`} >
                                        Edit
                                    </UncontrolledTooltip>
                                </Link>
                            </li>

                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-danger"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        //console.log("ON DELETE: ", jobData);
                                        onClickDelete(jobData);
                                    }}
                                    id={`deletetooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-delete-outline" />
                                    <UncontrolledTooltip placement="top" target={`deletetooltip-${cellProps.row.original.id}`}>
                                        Delete
                                    </UncontrolledTooltip>
                                </Link>
                            </li>
                        </ul>
                    );
                }
            },
        ],
        []
    );

    return (
        <React.Fragment>
            <DeleteModal
                show={deleteModal}
                onDeleteClick={handleDeleteAcademicCycleConfig}
                onCloseClick={() => setDeleteModal(false)}
            />
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Cycles" breadcrumbItem="Liste des cycles" />
                    {
                        isLoading ? <Spinners setLoading={setLoading} />
                            :
                            <Row>
                                <Col lg="12">
                                    <Card>
                                        <CardBody className="border-bottom">
                                            <div className="d-flex align-items-center">
                                                <h5 className="mb-0 card-title flex-grow-1"></h5> 
                                                <div className="flex-shrink-0">
                                                    <Link to="#!" onClick={onClickNewAcademicCycleConfig} className="btn btn-primary me-1">Ajouter un cycle</Link>
                                                    
                                                </div>
                                            </div>
                                        </CardBody>
                                        <CardBody>
                                            <TableContainer
                                                columns={columns}
                                                data={academicCycleConfigs || []}
                                                isCustomPageSize={true}
                                                isGlobalFilter={true}
                                                //isJobListGlobalFilter={false}
                                                isPagination={true}
                                                SearchPlaceholder="Rechercher ..."
                                                tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                                                theadClass="table-light"
                      
                        
                                                
                                                //tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                                                pagination="pagination"
                                                paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                            />
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                    }
                    {/* Modal séparé */}
                    <AcademicCycleConfigModal
                        modal={modal}
                        toggle={toggle}
                        isEdit={isEdit}
                        academicCycleConfig={academicCycleConfig}
                        onSubmit={(payload) => {
                        if (isEdit) {
                            dispatch(onUpdateAcademicCycleConfig(payload));
                        } else {
                            dispatch(onAddNewAcademicCycleConfig(payload));
                        }
                        toggle(); // 🔹 Fermeture automatique après succès
                        }}
                    />
                </div>
            </div>
            <ToastContainer />
        </React.Fragment>
    );
}


export default AcademicCycleConfigList;